import { render, staticRenderFns } from "./riskAssesment.vue?vue&type=template&id=7e3ce268&scoped=true&"
import script from "./riskAssesment.vue?vue&type=script&lang=js&"
export * from "./riskAssesment.vue?vue&type=script&lang=js&"
import style0 from "./riskAssesment.vue?vue&type=style&index=0&id=7e3ce268&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e3ce268",
  null
  
)

export default component.exports